import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEarRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 25,
	viewBox: "0 0 18 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 25C8.24177 18.2905 9.00623 10.3041 2.83064 0C10.6219 4.58187 20.3282 13.0068 17.4975 25H0Z",
		fill: "#CCCACA"
	})
});
export default SvgEarRight;
